import { HAS_ERROR, 
    SHOW_ACTIVITY, 
    IS_CONTENT_LOADING, 
    IS_PAGE_LOADING, 
    UPDATE_CURRENT_COLLECTION, 
    AFFILIATE_COLLECTION, 
    SAVE_FILTERED_ACTIVITIES, 
    FILTER_APPLIED,
    LOCATION_FILTER_APPLIED,
    CATEGORY_FILTER_APPLIED,
    AFFILIATE_LOGO,
    PAGE_NOT_FOUND } from '../actions/constant';
// import {combineReducers} from 'redux';
const initialState = {
    collections: {
        current: {},
        fromAffiliate: []
    },
    affiliateLogo: '',
    affiliateUsername: '',
    affiliateName: '',
    affiliateId: '',
    activities: [],
    filters: {
        status: false,
        location: [],
        category: [],
        activities: []
    },
    sortBy: 'popularity',
    contentLoading: false,
    pageLoading: false,
    hasError: false,
    pageNotFound: false
};
function mainReducer(state = initialState, action){
    switch (action.type) {
        case IS_PAGE_LOADING:
            return {...state, pageLoading: action.pageLoading};
        case IS_CONTENT_LOADING:
            return {...state, contentLoading: action.contentLoading};
        case HAS_ERROR:
            return { ...state, hasError: action.hasError};
        case SHOW_ACTIVITY:
            return {...state, activities: action.activities};
        case UPDATE_CURRENT_COLLECTION:
            return {...state, collections: {...state.collections, current:action.collection}}; 
        case AFFILIATE_COLLECTION:
            return {...state, collections: {...state.collections, fromAffiliate:action.fromAffiliate}}; 
        case SAVE_FILTERED_ACTIVITIES:
            return {...state, filters: {...state.filters, activities:action.activities}}; 
        case FILTER_APPLIED:
            return {...state, filters: {...state.filters, status:action.status}};
        case LOCATION_FILTER_APPLIED:
            return {...state, filters: {...state.filters, location:action.location}};
        case CATEGORY_FILTER_APPLIED:
            return {...state, filters: {...state.filters, category:action.category}}; 
        case AFFILIATE_LOGO:
            return {...state, affiliateId: action.affiliate.id, affiliateLogo: action.affiliate.logo, affiliateUsername:action.affiliate.username, affiliateName: action.affiliate.name}; 
        case PAGE_NOT_FOUND:
            return {...state, pageNotFound: action.payload}
        default:
            return state
    }
}
// const rootReducer = (state = initialState, action) => state;
// const rootReducer = combineReducers({
//     loadActivities,
//     pageLoading,
//     contentLoading,
//     hasError
// });

export default mainReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js